export default "__VITE_ASSET__$c8OBz5q__"